module.exports = __webpack_public_path__ + "static/media/Template_12.0adf8e13.png";